import { render, staticRenderFns } from "./editTypeReport.vue?vue&type=template&id=f6c1be66&"
import script from "./editTypeReport.vue?vue&type=script&lang=js&"
export * from "./editTypeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports